import { Injectable } from "@angular/core";
import { IComponentResolver, InjectionContext } from '@nexxe/plugin-injector';
import { Observable } from 'rxjs';
import { DmDataModelManagerService, DmWidgetManagerService } from '@nexxe/core';
import { CustomerInfoEntryService } from './services/bn-customer-info-v2.service';
import { Sections, ISupplierRegistration} from '@nexxe/bn-registration-core-services'
import { CdsService } from '@nexxe/cds';

// declare var userInfo : any;
@Injectable()
export class EntryResolver implements IComponentResolver<any> {
	constructor(
		private dataModelService: DmDataModelManagerService,
		private customerInfoEntryService: CustomerInfoEntryService,
	) { }
	resolve(context: InjectionContext) {
		this.customerInfoEntryService.callGlobalLoader("loadderstart");
		this.customerInfoEntryService.currentProject = this.dataModelService.getById('currentProject');
		this.customerInfoEntryService.currentProjectMetaData = this.dataModelService.getById(this.customerInfoEntryService.currentProject);
		let supplyRegistrationInfo: ISupplierRegistration = this.dataModelService.getById(Sections.UserInfoRegistration);
		if (!supplyRegistrationInfo)
			this.customerInfoEntryService.getSectionsModelData();
		this.customerInfoEntryService.loadPartnerdata();
		// if (!supplyRegistrationInfo)
		// 	return this.customerInfoEntryService.getSectionsModelData();
	}
}


